import { of } from "rxjs";
import { AjaxError } from "rxjs/ajax";
import { map, catchError } from "rxjs/operators";
import { HttpMethod, ServerResponseStatus } from "./types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import { mergeMap } from "../otel/rxjs.js";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../node_modules/moment/dist/moment.js";
import { ajax } from "./ajaxProxy.js";
import { fetchWithTracing } from "./fetchProxy.js";
class RestService {
  _userManager;
  constructor(userManager) {
    this._userManager = userManager;
  }
  get(restRequest, parentSpan, withAuth = true, responseType) {
    return this.sendRequest(HttpMethod.Get, restRequest, parentSpan, withAuth, null, responseType);
  }
  post(restRequest, parentSpan, withAuth = true, contentType = "application/json") {
    return this.sendRequest(HttpMethod.Post, restRequest, parentSpan, withAuth, contentType);
  }
  patch(restRequest, parentSpan, withAuth = true, contentType = "application/json") {
    return this.sendRequest(HttpMethod.Patch, restRequest, parentSpan, withAuth, contentType);
  }
  delete(restRequest, parentSpan, withAuth = true, contentType = "application/json") {
    return this.sendRequest(HttpMethod.Delete, restRequest, parentSpan, withAuth, contentType);
  }
  put(restRequest, parentSpan, withAuth = true, contentType = "application/json") {
    return this.sendRequest(HttpMethod.Put, restRequest, parentSpan, withAuth, contentType);
  }
  getBody(method, restRequest, contentType) {
    return method !== HttpMethod.Get ? contentType === "application/json" ? JSON.stringify(restRequest.body) : restRequest.body : void 0;
  }
  getUser() {
    return this._userManager.getUserExtended();
  }
  parseError(error) {
    return error instanceof AjaxError ? this.parseAjaxError(error) : this.parseUnknownError(error);
  }
  parseAjaxError(error) {
    return {
      status: ServerResponseStatus.Failed,
      message: error.message,
      errors: (error.response ? this.parseServerErrorResponse(error.response) : [
        {
          code: error.status?.toString() ?? null,
          message: error.message,
          values: [JSON.stringify(error)]
        }
      ])?.map((e) => ({ ...e, statusCode: error?.status ?? null }))
    };
  }
  parseServerErrorResponse(error) {
    return [
      {
        code: error.error_code?.toString() ?? null,
        message: error.msg,
        traceId: error.traceid,
        values: [JSON.stringify(error)]
      }
    ];
  }
  parseUnknownError(error) {
    return {
      status: ServerResponseStatus.Failed,
      message: error.message,
      errors: [
        {
          code: error.name,
          message: error.message,
          values: [JSON.stringify(error)]
        }
      ]
    };
  }
}
class RestXhrService extends RestService {
  _ajax;
  constructor(tracingService, userManager) {
    super(userManager);
    this._ajax = ajax(tracingService);
  }
  sendRequest(method, restRequest, parentSpan, withAuth = true, contentType, responseType = "json") {
    const contentTypeHeader = contentType && contentType !== "auto" ? { ["Content-Type"]: contentType } : {};
    return this.getUser().pipe(
      mergeMap((user) => {
        const authHeader = withAuth ? { ...user.authHeaders } : {};
        const request = {
          method,
          headers: { ...authHeader, ...contentTypeHeader },
          body: this.getBody(method, restRequest, contentType),
          url: `${restRequest.endpoint}?${restRequest.query ?? ""}`,
          withCredentials: restRequest?.withCredentials ?? true,
          responseType
        };
        return this._ajax(request, user.basicInfo, parentSpan).pipe(
          map((resp) => ({
            status: ServerResponseStatus.Success,
            requestPayload: restRequest,
            responsePayload: resp
          })),
          catchError((err) => {
            return of({
              requestPayload: restRequest,
              responsePayload: null,
              ...this.parseError(err)
            });
          })
        );
      })
    );
  }
}
class RestFetchApiService extends RestService {
  _fetch;
  constructor(tracingService, userManager) {
    super(userManager);
    this._fetch = fetchWithTracing(tracingService);
  }
  sendRequest(method, restRequest, parentSpan, withAuth = true, contentType) {
    const contentTypeHeader = contentType ? { ["Content-Type"]: contentType } : {};
    return this.getUser().pipe(
      mergeMap((user) => {
        const authHeader = withAuth ? { ...user.authHeaders } : {};
        const request = {
          method,
          headers: { ...authHeader, ...contentTypeHeader },
          body: this.getBody(method, restRequest, contentType)
        };
        return this._fetch(`${restRequest.endpoint}?${restRequest.query ?? ""}`, request, user.basicInfo, parentSpan).pipe(
          map((resp) => ({
            status: ServerResponseStatus.Success,
            requestPayload: restRequest,
            responsePayload: resp
          })),
          catchError((err) => {
            return of({
              requestPayload: restRequest,
              responsePayload: null,
              ...this.parseError(err)
            });
          })
        );
      })
    );
  }
}
export {
  RestFetchApiService,
  RestService,
  RestXhrService
};
//# sourceMappingURL=restService.js.map
